window.Products.DeviceCase.IphoneXSMax = function() {
};
window.Products.DeviceCase.IphoneXSMax.inherits(window.Products.DeviceCase.DeviceCase);

window.Products.DeviceCase.IphoneXSMax.id = 81;
window.Products.DeviceCase.IphoneXSMax.slug = 'iphonexsmax';
window.Products.DeviceCase.IphoneXSMax.has_3d = true;
window.Products.DeviceCase.IphoneXSMax.dpi = 300;

window.Products.DeviceCase.IphoneXSMax.prototype.set3dProperties = function(modelViewer) {
	this.updateThreeTexture(modelViewer);
	modelViewer.object.position.y = -0.71;
	modelViewer.object.rotation.x = 90 * (Math.PI/180);
	modelViewer.camera.position.z = 8;
};

window.Products.DeviceCase.IphoneXSMax.prototype.setThreeControls = function(controls) {
	controls.minDistance = 3.1;
	controls.maxDistance = 4.1;
};

window.Products.DeviceCase.IphoneXSMax.prototype.updateThreeTexture = function(modelViewer) {
	modelViewer.object.children[0].material[0].map = modelViewer.texture;
};